/**
 * LinkedIn Insight Tag conversion tracking.
 *
 * Conversion IDs are created in LinkedIn Campaign Manager
 * (Account Assets > Conversions). Add new IDs here as needed.
 */

export const LINKEDIN_CONVERSIONS = {
  // Tracked automatically by the Insight Tag -- no lintrk() call needed.
  // Listed here for reference only.
  // PAGE_VIEW: 25123524,

  // Event-based conversions -- create in Campaign Manager and add IDs here.
  // These are fired via trackLinkedInConversion() on form success.
  SIGNUP: null,
  DEMO_REQUEST: null,
  DOWNLOAD_COMPLETE: 2512353,
};

export function trackLinkedInConversion(conversionId) {
  if (typeof window.lintrk === 'function' && conversionId) {
    window.lintrk('track', { conversion_id: conversionId });
  }
}
